import { Popover }from 'antd'
import { Filter } from 'react-feather'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import AttributeFilter from './Filters/AttributeFilter'
import RelationFilter from './Filters/RelationFilter'
import './HeaderFilter.scss'

FilterComponent = ({ column }) ->
  if column.relationConf
    <RelationFilter column={column} />
  else
    <AttributeFilter column={column} />

HeaderFilter = ({ column, isLastCol }) ->

  [{ filters }, dispatch] = useSpreadSheetData()

  <Popover
    content={<FilterComponent column={column} />}
    placement={if isLastCol then "bottomLeft" else "bottom"}
    arrowPointAtCenter={true}
    trigger="click"
    overlayClassName="header-filter"
    onClick={(e) -> e.stopPropagation()}
    onMouseMove={(e) -> e.stopPropagation()}
    onMouseUp={(e) -> e.stopPropagation()}
  >
    <Filter
      data-testid="#{column.key}-filter-button"
      style={{
        width: 12,
        height: 14,
        top: 2,
        position: 'relative',
        marginLeft: 10,
        color: if filters[column.key] then '#1f7dcc'
      }}
    />
  </Popover>

export default HeaderFilter
